import React, { useEffect, useState } from "react";
import { Button, Checkbox, Input, Modal, Select, Space, Statistic, Table } from "antd";
import Styles from "./Styles";
import SearchArea from "../../components/moleculas/SearchArea";
import PopRegistServiceUse from "./PopRegistServiceUse";
import PopManageArea from "./PopManageArea";
import PopManageDevice from "./PopManageDevice";
import PopServiceUserInfo from "./PopServiceUserInfo";
import PopServiceChange from "./PopServiceChange";
import moment from "moment";
import { apiGet, apiGetPath, apiPost, apiPutPath, cognitoPostUser } from "../../api/api";
import { getSessionParam, isEmpty, setSessionParam } from "../../utils/comm";

const { Option } = Select;
const { Search } = Input;
const { Column } = Table;

// 상태 Class
const getStatusClass = (status) => {
  switch (status) {
    case "SUS00010":
      return "status-inUse";
    case "SUS00020":
      return "status-expire";
    case "SUS00030":
      return "status-cancel";
    default:
      return status;
  }
};

function ManageServiceUse() {
  // Parameter Save
  const [defaultValue] = useState({
    catCd: getSessionParam("catCd"),
    catNm: getSessionParam("catNm"),
  });

  const [isModalServiceUserInfo, setIsModalServiceUserInfo] = useState(false);
  const [isModalServiceChange, setIsModalServiceChange] = useState(false);
  const [isModalRegistVisible, setIsModalRegistVisible] = useState(false);
  const [isModalAreaVisible, setIsModalAreaVisible] = useState(false);
  const [isModalDeviceVisible, setIsModalDeviceVisible] = useState(false);

  const [serviceList, setServiceList] = useState();
  const [catCdList, setCatCdList] = useState(
    !isEmpty(defaultValue.catCd) && !isEmpty(defaultValue.catNm)
      ? [{ catCd: defaultValue.catCd, catNm: defaultValue.catNm }]
      : []
  );
  const [selectBox, setSelectBox] = useState(defaultValue.catCd);
  const [selectBoxNm, setSelectBoxNm] = useState(defaultValue.catNm);
  const [checked, setChecked] = useState(false);
  const [search, setSearch] = useState();
  const [userInfo, setUserInfo] = useState([]);
  const [row, setRow] = useState();
  const [req, setReq] = useState();
  const [stat, setStat] = useState();

  // [SVC-0104014001] 서비스 이용 목록 조회
  const onSearch = async () => {
    const param = checked === true ? "SUS00010" : "";
    // const response = await apiGet('Service?catCd=' + selectBox + '&statCd=' + param + '&searchKeyword=' + search + '&sort=');
    const response = await apiGet("Service", {
      params: {
        catCd: selectBox,
        statCd: param,
        searchKeyword: search,
      },
    });

    setSessionParam({ catCd: selectBox, catNm: selectBoxNm });

    try {
      setServiceList([]);
      if (response.data.code === 0) {
        setServiceList(response.data.data);
      }
    } catch (error) {}
  };

  // 서비스변경 modal
  const showModalServiceChange = async (e) => {
    setIsModalServiceChange(true);
    setReq(e.svcReqId);
    setStat(e.statCd);

    const response = await apiGetPath(`Service/${e.svcReqId}`);
    try {
      if (response.code === 0) {
        setUserInfo(response.data);
        setReq(e);
      } else if (response.code === 10) {
        setUserInfo([]);
      }
      // apiServiceCall();
    } catch (error) {}
  };

  // [SVC-0104014002] 서비스 상세 조회
  const showModalUserInfo = async (svcReqId) => {
    const response = await apiGetPath(`Service/${svcReqId}`);
    try {
      if (response.code === 0) {
        setReq(svcReqId);
        setUserInfo(response.data);
      } else if (response.code === 10) {
        setUserInfo([]);
      }
    } catch (e) {}
    setIsModalServiceUserInfo(true);
  };

  // [SVC-0104011001] 서비스 이용 등록
  const onFinishIns = async (props) => {
    const siteCorpNum = props.siteCorpNum === undefined ? null : props.siteCorpNum;

    if (props["startDt"].format("YYYYMMDD") >= props["endDt"].format("YYYYMMDD")) {
      Modal.confirm({
        title: "서비스 일자 확인",
        icon: null,
        content: "[서비스 만료일]을 [서비스 요청일] 이후로 입력하세요.",
        okText: "확인",
        centered: true,
        closable: true,
        cancelButtonProps: { style: { display: "none" } },
      });
      return;
    }

    const values = {
      ...props,
      startDt: props["startDt"].format("YYYY-MM-DD"),
      endDt: props["endDt"].format("YYYY-MM-DD"),
      userId: sessionStorage.getItem("userId"),
      siteCorpNum: siteCorpNum,
    };
    const response = await apiPost("Service", values);
    try {
      if (response.data.code === 0) {
        // setServiceList([...serviceList, values]);
        setIsModalRegistVisible(false);
        await apiServiceCall();

        // 사용자 추가 기능 반영
        const mUserId = response.data.data;

        if (isEmpty(mUserId)) {
          return;
        }

        const params = {
          "userid": mUserId,
          "username": values.userNm,
          "email": values.mail,
          "password": "TempPassword123!@",
        }

        await cognitoPostUser(params);

        pwSendConfirm();

      } else if (response.data.code === 23) {
      }
    } catch (error) {}
  };

  // [SVC-0104012003] 서비스 이용자 정보 수정 (put)
  const onFinishInfo = async (e) => {
    setIsModalServiceUserInfo(false);
    const param = {
      svcReqId: e.svcReqId,
      compNm: e.compNm,
      compCorpNum: e.compCorpNum,
      siteNm: e.siteNm,
      siteCorpNum: e.siteCorpNum,
      address: e.address,
      userNm: e.userNm,
      mail: e.mail,
      telNum: e.telNum,
    };
    await apiPutPath(`Service/user`, param);
    try {
      await apiServiceCall();
    } catch (err) {}
  };

  // [SVC-0104012001] 서비스 변경 (put)
  const onFinishChange = async (props) => {
    if (props["startDt"].format("YYYYMMDD") >= props["endDt"].format("YYYYMMDD")) {
      Modal.confirm({
        title: "서비스 일자 확인",
        icon: null,
        content: "[서비스 만료일]을 [서비스 요청일] 이후로 입력하세요.",
        okText: "확인",
        centered: true,
        closable: true,
        cancelButtonProps: { style: { display: "none" } },
      });
      return;
    }

    const values = {
      ...props,
      startDt: props["startDt"].format("YYYY-MM-DD"),
      endDt: props["endDt"].format("YYYY-MM-DD"),
      userId: sessionStorage.getItem("userId"),
    };
    await apiPutPath("Service", values);
    try {
      setIsModalServiceChange(false);
      await onSearch();
    } catch (error) {}
  };

  // 전체리스트 [SVC-0104014001]
  const apiServiceCall = async () => {
    const response = await apiGet("Service?catCd=&?statCd=&?searchKeyword=&?sort=");
    try {
      if (response.data.code === 0) {
        setServiceList(response.data.data);
      } else if (response.data.code === 10) {
        setServiceList([]);
      }
    } catch (error) {}
  };
  useEffect(() => {
    apiServiceCatCdCall().then();
  }, []);

  // [SVC-0104014010] 서비스 종류 조회(카탈로그)
  const apiServiceCatCdCall = async () => {
    const response = await apiGet("Service/list");
    try {
      setCatCdList([]);
      if (response.data.code === 0) {
        setCatCdList(response.data.data);
        onSearch().then();
      }
    } catch (error) {}
  };

  // selectBoxHandle (카테고리 선택) *
  const onChangeSelectBoxList = (e, item) => {
    setSelectBox(item ? e : null);
    setSelectBoxNm(item ? item.children : null);
  };

  // checkBox 상태
  const onChangeCheckBox = (e) => {
    const stateCheckBox = e.target.checked;
    setChecked(stateCheckBox);
  };

  const onChangeSearch = (e) => {
    const getSearchText = e.target.value;
    setSearch(getSearchText);
  };

  // Reset
  const handleReset = () => {
    setServiceList();
    setChecked(false);
    setSearch("");
    setSelectBox("");
    setSelectBoxNm("");
    testReset();
  };

  const testReset = () => {
    apiServiceCall().then();
    apiServiceCatCdCall().then();
  };

  // 신규 등록 modal
  const showModalRegist = () => {
    setIsModalRegistVisible(true);
  };

  const showModalArea = (row) => {
    // const param = {
    //   svcId : row.svcId,
    //   siteId: row.siteId
    // }
    setRow(row);
    setIsModalAreaVisible(true);
  };

  const showModalDevice = async (row) => {
    setRow(row);
    setIsModalDeviceVisible(true);
  };

  function canConfirm() {
    Modal.confirm({
      title: "서비스 이용 취소",
      icon: null,
      content: "서비스 이용을 취소하시겠습니까? ",
      okText: "예",
      cancelText: "아니오",
      centered: true,
      onOk: () => serviceCancelComplete(req, "Service/cancel"),
    });
  }

  function delConfirm() {
    Modal.confirm({
      title: "서비스 이용 종료",
      icon: null,
      content: "서비스 이용을 종료하시겠습니까? ",
      okText: "예",
      cancelText: "아니오",
      centered: true,
      onOk: () => serviceCancelComplete(req, "Service/complete"),
    });
  }

  function pwSendConfirm() {
    Modal.confirm({
      title: "신규 등록 완료",
      icon: null,
      content: "해당 담당자 이메일로 임시 패스워드가 발송 되었습니다.",
      okText: "확인",
      centered: true,
      closable: true,
      cancelButtonProps: { style: { display: "none" } },
    });
  }

  // [SVC-0104012002] 서비스 이용 취소
  // [SVC-0104012004] 서비스 이용 종료
  const serviceCancelComplete = async (data, url) => {
    const param = {
      svcReqId: data.svcReqId,
      userId: sessionStorage.getItem("userId"),
    };
    await apiPutPath(url, param);
    try {
      setIsModalServiceChange(false);
      await apiServiceCall();
    } catch (error) {}
  };

  return (
    <Styles className='has-table-resize'>
      <h1 className='page-tit'>서비스 이용 관리</h1>
      <SearchArea
        leftExtra={
          <Space size={15}>
            <Select
              style={{ width: 250 }}
              onChange={onChangeSelectBoxList}
              // defaultValue={defaultValue.catCd}
              value={selectBox}
            >
              <Option value=''>신청서비스</Option>
              {catCdList.map((item, index) => (
                <Option value={item.catCd} key={index}>
                  {item.catNm}
                </Option>
              ))}
            </Select>
            <Checkbox checked={checked} onChange={onChangeCheckBox}>
              이용중 서비스만 조회
            </Checkbox>
          </Space>
        }
        rightExtra={
          <Space>
            <Search
              style={{ width: 220 }}
              // defaultValue={defaultValue.searchKeyword}
              value={search}
              placeholder='검색어 입력'
              onChange={onChangeSearch}
              onSearch={onSearch}
            />
            <Button className='btn-gray' onClick={handleReset}>
              초기화
            </Button>
            <Button onClick={showModalRegist} type='primary'>
              신규 등록
            </Button>
          </Space>
        }
      />

      <div className='tbl-resize-wrapper' style={{ minHeight: 300 }}>
        <Table dataSource={serviceList} bordered pagination={false} showSorterTooltip={false} scroll={{ x: 1500 }}>
          <Column
            title='No'
            dataIndex=''
            key='1'
            width='4%'
            render={(value, record, index) => <div key={index}>{index + 1}</div>}
          />
          <Column
            title='서비스 요청번호'
            dataIndex='svcReqId'
            key='2'
            sorter={(a, b) => a.svcReqId.localeCompare(b.svcReqId)}
            defaultSortOrder='descend'
            width='10%'
          />
          <Column
            title='고객사'
            dataIndex='compNm'
            key='3'
            sorter={(a, b) => a.compNm.localeCompare(b.compNm)}
            width='8%'
          />
          <Column
            title='사업장'
            dataIndex='siteNm'
            key='4'
            sorter={(a, b) => a.siteNm.localeCompare(b.siteNm)}
            width='10%'
          />
          <Column
            title='신청서비스'
            dataIndex='catNm'
            key='5'
            width='20%'
            sorter={(a, b) => a.catCd.localeCompare(b.catCd)}
            align='left'
          />
          <Column
            title='서비스개시일'
            dataIndex='startDt'
            key='6'
            width='8%'
            sorter={(a, b) => a.startDt.localeCompare(b.startDt)}
            render={(value) => moment(value).format("YYYY-MM-DD")}
          />
          <Column
            title='서비스만료일'
            dataIndex='endDt'
            key='7'
            width='8%'
            sorter={(a, b) => a.endDt.localeCompare(b.endDt)}
            render={(value, record) => {
              let endDtFm = moment(value).format("YYYY-MM-DD");
              if (record.statCd === "SUS00010")
                return {
                  props: {
                    style: {
                      background: Math.sign(moment().diff(endDtFm, "day")) < 0 ? "" : "#fde2e0",
                      color: Math.sign(moment().diff(endDtFm, "day")) < 0 ? "#5E6675" : "red",
                    },
                  },
                  children: <div>{endDtFm}</div>,
                };
              return {
                children: <div>{endDtFm}</div>,
              };
            }}
          />
          <Column
            title='구독기간'
            dataIndex='subPeriod'
            key='8'
            width='7%'
            sorter={(a, b) => a.subPeriod - b.subPeriod}
            render={(subPeriod) => <Statistic value={subPeriod} suffix='개월' />}
          />
          <Column
            title='월구독료'
            dataIndex='subPay'
            key='9'
            width='8%'
            sorter={(a, b) => a.subPay - b.subPay}
            render={(subPay) => <Statistic value={subPay === null ? "" : subPay} />}
          />
          <Column
            title='상태'
            dataIndex='statCd'
            key='10'
            width='6%'
            sorter={(a, b) => a.statCd.localeCompare(b.statCd)}
            render={(status, row) => (
              <Button
                danger
                className={getStatusClass(status)}
                onClick={() => {
                  showModalUserInfo(row.svcReqId).then();
                }}
              >
                {row.codeNm}
              </Button>
            )}
          />
          <Column
            title=''
            key='11'
            dataIndex='code'
            render={(code, row) => {
              if (row.statCd === "SUS00010") {
                return (
                  <Space size={[6]}>
                    <Button onClick={() => showModalServiceChange(row)} className='btn-compact'>
                      서비스 변경
                    </Button>
                    <Button onClick={() => showModalArea(row)} className='btn-compact'>
                      구역관리
                    </Button>
                    <Button onClick={() => showModalDevice(row)} className='btn-compact'>
                      디바이스 관리
                    </Button>
                  </Space>
                );
              } else {
                return (
                  <Space size={[6]}>
                    <Button disabled onClick={() => showModalServiceChange(row)} className='btn-compact'>
                      서비스 변경
                    </Button>
                    <Button disabled onClick={() => showModalArea(row)} className='btn-compact'>
                      구역관리
                    </Button>
                    <Button disabled onClick={() => showModalDevice(row)} className='btn-compact'>
                      디바이스 관리
                    </Button>
                  </Space>
                );
              }
            }}
          />
        </Table>
      </div>

      <Modal
        title='서비스 이용자 정보'
        visible={isModalServiceUserInfo}
        onCancel={() => setIsModalServiceUserInfo(false)}
        width={1187}
        centered
        okText='저장'
        okButtonProps={{ form: "formInfo", key: "formInfo", htmlType: "submit" }}
        cancelButtonProps={{ style: { display: "none" } }}
      >
        <PopServiceUserInfo children={userInfo} onFinish={onFinishInfo} />
      </Modal>

      <Modal
        title='서비스 변경'
        visible={isModalServiceChange}
        onCancel={() => setIsModalServiceChange(false)}
        width={1187}
        centered
        footer={[
          <Button
            disabled={stat === "SUS00010" ? "" : "disabled"}
            hidden={stat === "SUS00010" ? "" : "hidden"}
            onClick={canConfirm}
            form='ChangeForm'
            className='float-left btn-gray'
          >
            서비스 이용 취소
          </Button>,
          <Button className='float-left btn-gray' onClick={delConfirm}>
            서비스 이용 종료
          </Button>,
          // <Button className="float-left btn-gray" onClick={() => setIsModalServiceChange(false)}>서비스 이용 종료</Button>,
          <Button form='ChangeForm' key='ChangeForm' htmlType='submit' type='primary'>
            저장
          </Button>,
        ]}
      >
        <PopServiceChange form='ChangeForm' onFinish={onFinishChange} children={userInfo} />
      </Modal>

      <Modal
        destroyOnClose={true}
        title='구역관리'
        visible={isModalAreaVisible}
        onCancel={() => setIsModalAreaVisible(false)}
        width={670}
        centered
        footer={[
          // <Button key="back"  className="btn-lightBlue float-left" form="formArea">구역추가</Button>,
          <Button key='submit' htmlType='submit' type='primary' form='formArea'>
            저장
          </Button>,
        ]}
      >
        <PopManageArea form='formArea' children={row} />
      </Modal>

      <Modal
        destroyOnClose={true}
        title='디바이스 관리'
        width={764}
        visible={isModalDeviceVisible}
        okButtonProps={{ form: "formDevice", htmlType: "submit", key: "formDevice" }}
        onCancel={() => setIsModalDeviceVisible(false)}
        centered
        okText='저장'
        cancelButtonProps={{ style: { display: "none" } }}
      >
        <PopManageDevice id='formDevice' children={row} />
      </Modal>

      <Modal
        destroyOnClose={true}
        title='서비스 이용 등록'
        visible={isModalRegistVisible}
        onOk={() => setIsModalRegistVisible(false)}
        onCancel={() => setIsModalRegistVisible(false)}
        centered
        width={1187}
        okText='확인'
        footer={[
          <Button type='primary' form='formSvcIns' key='submit' htmlType='submit'>
            저장
          </Button>,
        ]}
      >
        <PopRegistServiceUse form='formSvcIns' onFinish={onFinishIns} children={catCdList} />
      </Modal>
    </Styles>
  );
}

export default ManageServiceUse;
